import React from 'react';
import {
  Box, Flex, Text, useColorModeValue,
} from '@chakra-ui/react';
import { FaCheck } from 'react-icons/fa';
import { useAppearance } from '../theme/AppearanceProvider';

// item 481 — the per-section "all caught up" state (Chad): a green check when a dashboard
// section has nothing left to act on. item 509 — the BIG celebratory check is now reserved for
// the ONE page-top CaughtUpHero; every per-section use is `compact` (a small inline check + text)
// so the dashboard isn't peppered with big circles (Chad).
const SectionCaughtUp: React.FC<{ text: string; compact?: boolean }> = ({ text, compact }) => {
  const { aurora } = useAppearance();
  const ring = useColorModeValue('green.400', 'green.300');
  const sub = useColorModeValue('green.700', 'green.200');

  if (compact) {
    return (
      <Flex align="center" sx={{ gap: '8px' }} py={4}>
        <Flex w="20px" h="20px" flexShrink={0} align="center" justify="center" borderRadius="full" bg={ring} color="white">
          <Box as={FaCheck} fontSize="10px" />
        </Flex>
        <Text fontSize="sm" fontWeight="medium" color={sub}>{text}</Text>
      </Flex>
    );
  }

  return (
    <Flex direction="column" align="center" textAlign="center" py={10}>
      <Box position="relative" mb={3}>
        {aurora && (
          <Box
            position="absolute"
            inset={0}
            borderRadius="full"
            boxShadow="0 0 44px 6px var(--chakra-colors-brandGreen-400)"
            opacity={0.55}
            pointerEvents="none"
          />
        )}
        <Flex w="64px" h="64px" align="center" justify="center" borderRadius="full" bg={ring} color="white">
          <Box as={FaCheck} fontSize="26px" />
        </Flex>
      </Box>
      <Text fontSize="sm" fontWeight="medium" color={sub}>{text}</Text>
    </Flex>
  );
};

SectionCaughtUp.defaultProps = { compact: false };

export default SectionCaughtUp;
